import MenuLessonItemView, { MenuLessonItemProps } from './MenuLessonItem';
import withInteractor from './MenuLessonItem.interactor';
import withPresenter from './MenuLessonItem.presenter';

export type { MenuLessonItemProps };

const MenuLessonItem = withInteractor(withPresenter(MenuLessonItemView));

export default MenuLessonItem;
